import React, { useState } from 'react';
import { useLocalization } from '../contexts/LocalizationContext';
import { X } from 'lucide-react';

interface AnnouncementBarProps {
  onHide?: () => void;
}

const AnnouncementBar: React.FC<AnnouncementBarProps> = ({ onHide }) => {
  const { language } = useLocalization();
  const [isVisible, setIsVisible] = useState(true);

  const handleHide = () => {
    setIsVisible(false);
    onHide?.();
  };

  if (!isVisible) return null;

  return (
    <div className="sticky top-0 z-50 bg-accent text-primary py-3 px-4 relative">
      <div className="max-w-7xl mx-auto flex items-center justify-center space-x-2 rtl:space-x-reverse">
        <div className="flex items-center space-x-2 rtl:space-x-reverse">
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
          <span className="font-semibold text-sm md:text-base">
            {language === 'ar' 
              ? '🎉 فترة التجربة المجانية - جميع المميزات متاحة مجاناً الآن!' 
              : '🎉 Free Trial Period - All Features Available for Free Now!'
            }
          </span>
        </div>
        <div className="hidden sm:block">
          <span className="text-primary/80 text-sm">
            {language === 'ar' ? 'ابدأ الآن واستمتع بجميع المميزات' : 'Start now and enjoy all features'}
          </span>
        </div>
      </div>
      <button
        onClick={handleHide}
        className="absolute top-1/2 right-4 transform -translate-y-1/2 text-primary/80 hover:text-primary transition-colors"
        aria-label={language === 'ar' ? 'إغلاق الإعلان' : 'Close announcement'}
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
